import BasePresenter from "../../redare/presenter/BasePresenter";
import * as TaskReceiverHttp from "../http/TaskReceiverHttp";

/**
 * Created by RdevPlugins.JsPresenterBuilderAction on 2021-11-23 10:13:03.
 */

export default class TaskReceiverPresenter extends BasePresenter {

    /**
     * @param body: {sysCode, title, taskId, userId, userAccount, userName, departmentId, departmentName, unityUserId, status, nodeId, nodeName, result, startTime, endTime, url}
     * @param query: {}
     * @returns Promise
     */
    addTaskReceiver(body, query, success, fails) {

        if (this._onBeforeAddTaskReceiver) {
            let data = this._onBeforeAddTaskReceiver(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        TaskReceiverHttp.addTaskReceiver(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeAddTaskReceiverSuccess) {
                    result = this._onBeforeAddTaskReceiverSuccess(result, {body, query});
                }

                if (this.view && this.view._onAddTaskReceiverSuccess) {
                    this.view._onAddTaskReceiverSuccess(result, {body, query});
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if(!fails(error)){
                        this.tipError(error);
                    }
                }else{
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {unityUserId, status, result, userId, userName, userAccount, endTime, url, where: {id, taskId, userId, nodeId, sysCode}}
     * @param query: {}
     * @returns Promise
     */
    editTaskReceiver(body, query, success, fails) {

        if (this._onBeforeEditTaskReceiver) {
            let data = this._onBeforeEditTaskReceiver(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        TaskReceiverHttp.editTaskReceiver(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeEditTaskReceiverSuccess) {
                    result = this._onBeforeEditTaskReceiverSuccess(result, {body, query});
                }

                if (this.view && this.view._onEditTaskReceiverSuccess) {
                    this.view._onEditTaskReceiverSuccess(result, {body, query});
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if(!fails(error)){
                        this.tipError(error);
                    }
                }else{
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {id}
     * @param query: {}
     * @returns Promise
     */
    deleteTaskReceiver(body, query, success, fails) {

        if (this._onBeforeDeleteTaskReceiver) {
            let data = this._onBeforeDeleteTaskReceiver(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        TaskReceiverHttp.deleteTaskReceiver(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeDeleteTaskReceiverSuccess) {
                    result = this._onBeforeDeleteTaskReceiverSuccess(result, {body, query});
                }

                if (this.view && this.view._onDeleteTaskReceiverSuccess) {
                    this.view._onDeleteTaskReceiverSuccess(result, {body, query});
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if(!fails(error)){
                        this.tipError(error);
                    }
                }else{
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {id, queryFields}
     * @param query: {}
     * @returns Promise
     */
    getTaskReceiver(body, query, success, fails) {

        if (this._onBeforeGetTaskReceiver) {
            let data = this._onBeforeGetTaskReceiver(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        TaskReceiverHttp.getTaskReceiver(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeGetTaskReceiverSuccess) {
                    result = this._onBeforeGetTaskReceiverSuccess(result, {body, query});
                }

                if (this.view && this.view._onGetTaskReceiverSuccess) {
                    this.view._onGetTaskReceiverSuccess(result, {body, query});
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if(!fails(error)){
                        this.tipError(error);
                    }
                }else{
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {queryFields, key, sysCode, taskId, flowId, userId, userAccount, unityUserId}
     * @param query: {curPage,pageSize}
     * @returns Promise
     */
    findTaskReceiverPage(body, query, success, fails) {

        if (this._onBeforeFindTaskReceiverPage) {
            let data = this._onBeforeFindTaskReceiverPage(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        TaskReceiverHttp.findTaskReceiverPage(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeFindTaskReceiverPageSuccess) {
                    result = this._onBeforeFindTaskReceiverPageSuccess(result, {body, query});
                }

                if (this.view && this.view._onFindTaskReceiverPageSuccess) {
                    this.view._onFindTaskReceiverPageSuccess(result, {body, query});
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if(!fails(error)){
                        this.tipError(error);
                    }
                }else{
                    this.tipError(error);
                }
            }
        );
    }

}